// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_6444e049b8--hidden--l7K5W"};